import ToastComponent from "./index.vue";

const ExtraToast = {
    install: (Vue) => {
        // 创建一个vue的子类组件
        const ToastConstructor = Vue.extend(ToastComponent);

        // 创建一个该子类的实例,并挂载到一个元素上
        const instance = new ToastConstructor();

        // 将这个实例挂载到动态创建的元素上,并将元素添加到全局结构中
        instance.$mount(document.createElement('div'));
        document.body.appendChild(instance.$el);
        // 在Vue的原型链上注册方法，控制组件
        // bol为开启模态框， val是否开启关闭按钮
        Vue.prototype.$extraToast = (bol, val) => {
            // instance.active()
            instance.modal = bol,
            instance.val = val
            // instance.status = val
        };
    }
};

export default ExtraToast;
